<template>
    <a-upload list-type="picture-card" accept="image/jpeg,image/png" :show-upload-list="false" action="action" :before-upload="beforeUpload" :customRequest="doUpload">
        <div v-if="imgUrl" :style="{ width: '100px', height: '100px' }">
            <img :src="imgUrl" :style="{ width: '100%', height: '100%' }" />
        </div>
        <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" :style="{ fontSize: '32px', color: '#999' }" />
            <div :style="{ marginTop: '8px', color: '#666' }">
                上传图片
            </div>
        </div>
    </a-upload>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        img: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            imgUrl: '',
            loading: false
        }
    },
    watch: {
        img(ov) {
            this.imgUrl = ov
        }
    },
    methods: {
        doUpload(upload) {
            this.loading = true
            this.$http
                .post(
                    '/sys/base/upload/image',
                    {
                        file: upload.file,
                        type: this.type
                    },
                    {
                        onUploadProgress: progressEvent => {
                            const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                            upload.onProgress({
                                percent: complete
                            })
                        }
                    }
                )
                .then(result => {
                    this.loading = false
                    if (result.code === 0) {
                        let obj = {
                            name: upload.file.name,
                            url: result.data.url
                        }
                        this.imgUrl = obj.url
                        this.$emit('update:img', obj.url)
                        upload.onSuccess(obj)
                    }
                })
                .catch(err => {
                    this.loading = false
                    upload.onError(err)
                })
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
            if (!isJpgOrPng) {
                this.$message.error('请上传[JPEG/PNG]格式图片')
            }
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error('请上传小于2MB的图片文件')
            }
            return isJpgOrPng && isLt2M
        }
    }
}
</script>
